<template>
  <div class="matchDoor">
    <el-form-item :label="$t('newSurvey.matchDoor')" prop="">
      <div class="doors" style="display: flex">
        <el-upload v-show="false" :action="'#'" :on-success="() => {}" :before-upload="beforeUpload">
          <el-button ref="uploadBtn" v-show="false">点击上传</el-button>
        </el-upload>
        <div style="display: flex" @click="upload">
          <el-input :placeholder="$t('chooseFile')" v-model="fileName" :disabled="true"></el-input>
          <el-button>{{ $t('import') }}</el-button>
        </div>
        <el-button @click="exportDoor">{{ $t('export') }}</el-button>
        <el-button style="display: flex; margin-left: 20px" @click="previewHandler">{{ $t('see') }}</el-button>
        <el-button type="text" style="margin-left: 20px" @click="downloadTemplate">
          <i class="el-icon-info"></i>
          {{ $t('downloadTemp') }}
        </el-button>
      </div>
    </el-form-item>
    <el-drawer :title="$t('newSurvey.matchDoor')" :visible.sync="preview" direction="rtl" size="50%" :close="rollbackDoor">
      <div>
        <div style="display: flex; padding: 0 20px 20px 20px">
          <el-input :placeholder="$t('filters.choosePOSID')" v-model="doorSearch"></el-input>
          <el-button @click="doorFilter"><i class="el-icon-search"></i>查询</el-button>
        </div>
        <el-table :data="getCurrentDoors()" ref="doorTableData" tooltip-effect="dark" border style="width: 100%" :key="2">
          <el-table-column sortable prop="name" :label="$t('filters.doorName')" width="180" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="cellphone" label="门店编号" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="valid" :label="$t('filters.city')" show-overflow-tooltip>
          </el-table-column>
          <el-table-column :label="$t('operation')" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="delDoor(scope)"><i class="el-icon-delete"></i>{{ $t('delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="currentChange"
            :current-page="current"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "matchDoor",
  props: {
    label: '',
    value: Array,
    labelWidth: ''
  },
  data(){
    return {
      // 适用门店相关数据 start
      fileName: "",
      preview: false,
      doorInfos: [],
      doorInfoBack: this.value,
      doorSearch: "",
      actionUrl: "/offline-course/course/courseDoorImport", // todo: 下载模板地址
      pageSize: 10,
      current: 1,
      total: 0
    }
  },
  methods: {
    // 适用门店相关的方法 start
    previewHandler() {
      this.preview = true;
      // console.log(this.courseWorker.multipleChoices);
    },
    upload() {
      this.$refs.uploadBtn.$el.click();
    },
    beforeUpload(file) {
      let that = this;
      const isSupport =
        file.name.toLowerCase().endsWith(".xls") ||
        file.name.toLowerCase().endsWith(".xlsx");

      if (!isSupport) {
        this.$message.error("仅支持excel文件");
        return false;
      }

      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", 1);
      window.instance.post(window.surveyUrl + "/head/discern", formData).then((res) => {
        let { data } = res.data;
        that.doorInfos = [];
        // console.log(file.name);
        if (res.data.code === 200) {
          this.fileName = file.name;

          data.forEach((i) => {
            that.doorInfos.push(_.cloneDeep(i));
            console.log(i);
          });
          // that.ruleForm.doors = this.doorInfos.filter(i=>i.valid).map((i) => i.door);
          this.$emit('input', this.doorInfos)
          this.total = this.doorInfos.length
          this.doorInfoBack = JSON.parse(JSON.stringify(this.doorInfos));
          this.$message.success("导入成功！");
        } else {
          this.$message.error(res.data.message);
        }
      });

      return false;
    },
    async downloadTemplate() {
      let response = await window.instance({
        method: "get",
        responseType: "blob",
        url: "/offline-course/course/courseDoorImportTemplate",
      });

      let fileName = decodeURI(
        response.headers["content-disposition"].split("''")[1]
      );
      let res = response.data;
      const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    },
    rollbackDoor() {
      this.doorInfos = JSON.parse(JSON.stringify(this.doorInfoBack));
      this.$emit('input', this.doorInfos)
    },
    delDoor(scope) {
      this.doorInfos = this.doorInfos.filter(
        (i) => i.door != scope.row.door
      );
      this.doorInfoBack = JSON.parse(JSON.stringify(this.doorInfos));
      this.$emit('input', this.doorInfos)
      // this.ruleForm.doors = this.doorInfos.filter(i=>i.valid).map((i) => i.door);
    },
    doorFilter() {
      if (!this.doorSearch) {
        this.doorInfos = JSON.parse(JSON.stringify(this.doorInfoBack));
      } else {
        this.doorInfos = this.doorInfoBack.filter(
          (i) => i.cellphone == this.doorSearch
        );
      }
    },
    async exportDoor() {
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: '', // todo: 导出门店接口地址
        data: _.map(this.doorInfos, (door) => (door.cellphone))
      });
    },
    currentChange(index) {
      // 分页
      this.current = index;
      // this.getData();
    },
    getCurrentDoors() {
      const pageSize = this.pageSize
      return this.doorInfos.slice((this.current - 1) * pageSize, (this.current - 1) * pageSize + pageSize)
    }
    // 适用门店相关的方法 end
  },
  watch: {
    value: function(val, oldVal) {
      console.log('val', val)
      this.doorInfos = val
      this.total = this.doorInfos.length
    }
  },
  computed: {
    labelStyle() {
      const w = this.labelWidth || '100';
      return {
        width: w + 'px'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.matchDoor
  display: flex
  .label
    text-align: right
    vertical-align: middle
    float: left
    font-size: 14px
    color: #606266
    line-height: 36px
    padding: 0 12px 0 0
    -webkit-box-sizing: border-box
    box-sizing: border-box
    flex-shrink: 0

  .multiPickContent
    margin-top: 4px
    width: 100%
    line-height: 26px
  .paging
    margin: 20px 0 0 10px
</style>



// WEBPACK FOOTER //
// src/openSurvey/components/matchDoor.vue